function fetchAuthenticatedUser() {
  return fetch(
    `https://${process.env.API_HOST}/v1/users/me?include_entity=true&include_students=true`,
    {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-vt-requestid': window.components?.tracking?.request_id,
      },
      mode: 'cors',
    }
  ).then((res) => res.json().catch(() => undefined));
}

export default fetchAuthenticatedUser;
